import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colleagueSection", "classroomSection"]

  toggle(event) {
    const mode = event.currentTarget.value

    if (mode === "classroom") {
      this.classroomSectionTarget.classList.remove("hidden")
      this.colleagueSectionTarget.classList.add("hidden")
      this.#disableInputs(this.colleagueSectionTarget)
      this.#enableInputs(this.classroomSectionTarget)
    } else {
      this.colleagueSectionTarget.classList.remove("hidden")
      this.classroomSectionTarget.classList.add("hidden")
      this.#disableInputs(this.classroomSectionTarget)
      this.#enableInputs(this.colleagueSectionTarget)
    }
  }

  #disableInputs(section) {
    section.querySelectorAll("select, input").forEach((input) => {
      input.disabled = true
    })
  }

  #enableInputs(section) {
    section.querySelectorAll("select, input").forEach((input) => {
      input.disabled = false
    })
  }
}
